import {useTranslation} from "react-i18next";
import LanguageContentSection from "../../common/LanguageContentSection";
import logo from "../../../../assets/Logo/acte_masterclass_logo_dark.png";
import React, {useEffect} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {loginService} from "../../../../services/authService/loginService";
import {loginSuccess, setAccessToken, setUserData} from "../../../../redux/authSlice";
import {toast} from "react-toastify";
import {profileSettingService} from "../../../../services/profileSettingService/profileSettingService";

const LoginCallbackSection = () => {
    //  states start
    const { t } = useTranslation();

    const { search } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const params = new URLSearchParams(search);
        const rid = params.get('rid');
        const token = params.get('token');
        const code = params.get('code'); // Вариант B
        const payload = code ? { code } : { rid, token };

        loginService.exchangeMagic(payload)
            .then(async (response) => {
                if (response?.data?.data?.token) {
                    localStorage.setItem("access_token", response.data?.data?.token);
                    localStorage.setItem("masterClass", response.data?.data?.masterclass);
                    dispatch(setAccessToken(response.data?.data?.token));
                    const user = response?.data?.data?.user;
                    toast.success(response?.data?.message);
                    dispatch(loginSuccess(user));
                    localStorage.setItem("user", JSON.stringify(user));
                    profileSettingService.getUserProfileData(user?.id).then((response) => {
                        const fetchedUserData = response?.data?.data;
                        dispatch(setUserData(fetchedUserData));
                        navigate("/dashboard");
                    });
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((ex) => {
                toast.error(ex?.response?.data?.message);
            });
    }, [search]);

    // states end
    return (
        <>
            {/* login content section start */}
            <div className="login-content-section">
                {/* language selection start */}
                <div className="login-language-section">
                    <LanguageContentSection />
                </div>
                {/* language selection end */}

                {/* login content form start */}
                <div className="login-content-form">
                    <div className="login-catapult-logo">
                        <img crossOrigin="anonymous" src={logo} alt="Website Logo" className="logo-image" />
                    </div>
                    <div className="login-form">
                        <div>Signing you in…</div>
                    </div>
                </div>
                {/* login content form end */}

                <div className="login-footer">
                    <Link to="/">{t("COMMON.LOGIN.NOW")}</Link>
                </div>
            </div>
            {/* login content section end */}
        </>
    );
};

export default LoginCallbackSection;